import React from 'react';
const awards = () => {
    return (
<div>
    <img
        src="/assets/images/UpdatedAwards.jpg"
        width='600'
        alt ="Awards"
        
        />
</div>
    )
}
export default awards;